import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AppStateModel, selectAppState } from '../../../app.state';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { RouteNavigationService } from '../route-navigation.service';
import { Store } from '@ngxs/store';
import { RouteLocations } from '../route-locations.enum';

@Injectable()
export class LoggedInRouteGuardLogic {
  constructor(
    private _store: Store,
    private _routeNavigationService: RouteNavigationService,
    private _router: Router
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return selectAppState(this._store).pipe(
      filter((state: AppStateModel) => !!state?.isInitialized),
      take(1),
      map((applicationState: AppStateModel) => {
        const isLoggedIn = !!applicationState.session;
        const hasValidatedEmail = !!applicationState.session?.user.hasVerifiedEmail;
        const hasCompletedMfa = !!applicationState.session?.hasCompletedMfa;
        const currentUrl = state.url;

        if (!isLoggedIn) {
          this._routeNavigationService.goToLoginAsync()
            .then(() => {
            })
            .catch(() => {
              window.location.href = RouteLocations.Authentication.children.Login.absoluteUrl;
            });
        }

        if (isLoggedIn && !hasValidatedEmail) {
          this._routeNavigationService.goToEmailValidator()
            .then(() => {
            })
            .catch(() => {
              window.location.href = RouteLocations.Authentication.children.ValidateEmail.absoluteUrl;
            });
        }

        if (isLoggedIn && !hasCompletedMfa) {
          this._routeNavigationService.goToMfaAsync()
            .then(() => {
            })
            .catch(() => {
              window.location.href = RouteLocations.Authentication.children.Mfa.absoluteUrl;
            });
        }

        return isLoggedIn;
      }),
    );
  }
}

export const LoggedInRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  return inject(LoggedInRouteGuardLogic).canActivate(route, state);
};
